import { FC } from 'react';
import { format } from 'date-fns';

import { useGetCampaignDictionariesQuery } from 'src/api/campaigns/hooks';

import styles from './styles.module.css';

interface CampaignCalendarHeaderProps {
  campaignName: string;
  dateFrom: string;
  dateTo: string;
  campaignType: number;
  campaignGoal: number;
  locationType: number;
}
export const CampaignCalendarHeader: FC<CampaignCalendarHeaderProps> = ({
  campaignName,
  dateFrom,
  dateTo,
  campaignType,
  campaignGoal,
  locationType,
}) => {
  const { data: dictionaries } = useGetCampaignDictionariesQuery();

  const getCampaignTypeName = (id: number) =>
    dictionaries?.campaign_types.find((type) => type.id === id)?.name ||
    'Unknown Type';

  const getCampaignGoalName = (id: number) =>
    dictionaries?.campaign_goals.find((goal) => goal.id === id)?.name ||
    'Unknown Goal';

  const getLocationTypeName = (id: number) =>
    dictionaries?.location_types.find((location) => location.id === id)?.name ||
    'Unknown Location';

  return (
    <div className={styles.header}>
      <h2 className={styles.title}>{campaignName}</h2>
      <h4 className={styles.subtitle}>Duration</h4>
      <div className={styles.duration}>
        {format(new Date(dateFrom), 'd MMM, yy')} -{' '}
        {format(new Date(dateTo), 'd MMM, yy')}
      </div>
      <div className={styles.details}>
        <div className={styles.detailItem}>
          <strong>Campaign Type:</strong> {getCampaignTypeName(campaignType)}
        </div>
        <div className={styles.detailItem}>
          <strong>Campaign Goal:</strong> {getCampaignGoalName(campaignGoal)}
        </div>
        <div className={styles.detailItem}>
          <strong>Location Type:</strong> {getLocationTypeName(locationType)}
        </div>
      </div>
    </div>
  );
};
